export default {
  enableTranslation: false,
  translation: {
    sourceLang: '',
    targetLang: '',
  },
  activeTranslationInfo: {
    key: '',
    value: '',
    lang: '',
  },
}
